import cx from "classnames";
import React, { Component, Fragment } from "react";
import styles from "./style.module.scss";
class InputSearch extends Component {
  render() {
    const { icon, className } = this.props;
    return (
      <Fragment>
        {this.props.elements_html ? (
          <div
            className={cx(
              styles.form_group,
              styles.searchDoctor,
              styles[className]
            )}
          >
            <div className={styles.icons}>{icon || ""}</div>
            <div className={styles.form_control} onClick={this.props.onClick}>
              {this.props.title}
            </div>
          </div>
        ) : (
          <div className={cx(styles.form_group, styles[className])}>
            <div className={styles.icons}>{icon || ""}</div>
            <input
              type="search"
              onClick={this.props.onClick}
              onChange={this.props.onChange}
              onKeyUp={this.props.onKeyUp}
              onKeyPress={this.props.onKeyPress}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              value={this.props.value}
              className={cx(styles.form_control, {
                [styles.is_custom_input_modal]: this.props.is_custom_input_modal
              })}
              placeholder={this.props.title}
              autoFocus={this.props.autoFocus}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

export default InputSearch;
